export enum POP_EVENT_TYPE {
    OPEN = 'open',
    CLOSE = 'close',
    BACKDROP_CLICK = 'backdrop_click'
}
